class DoaFilterModel {
  constructor(doaFilterModel?: DoaFilterModel) {
    this.districtId = doaFilterModel ? doaFilterModel.districtId == undefined ? '' : doaFilterModel.districtId : '';
    this.branchId = doaFilterModel ? doaFilterModel.branchId == undefined ? '' : doaFilterModel.branchId : '';
  }
  districtId?: string;
  branchId?: string;
}

export { DoaFilterModel }

